import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IPosicaoCaminhaoPatioResponse } from 'src/app/services/PatioService/patio.model';
import { PatioService } from 'src/app/services/PatioService/patio.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

@Component({
  selector: 'app-consulta-posicao-patio',
  templateUrl: './consulta-posicao-patio.component.html',
  styleUrls: ['./consulta-posicao-patio.component.scss']
})
export class ConsultaPosicaoPatioComponent {
  form: FormGroup;
  isLoading = false;
  resultado: IPosicaoCaminhaoPatioResponse | null = null;
  consultado = false;

  constructor(
    private fb: FormBuilder,
    private patioService: PatioService,
    private swalAlert: SwalAlertService
  ) {
    this.form = this.fb.group({
      TX_PLCA_CAVA: ['', [Validators.required, Validators.pattern(/^[A-Z]{3}-?[0-9][A-Z0-9][0-9]{2}$/)]]
    });
  }

  onPlacaInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = (input.value || '').toUpperCase().replace(/[^A-Z0-9\-]/g, '').slice(0, 8);
    input.value = value;
    this.form.patchValue({ TX_PLCA_CAVA: value }, { emitEvent: false });
  }

  consultar(): void {
    const placa = (this.form.value.TX_PLCA_CAVA || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    this.form.patchValue({ TX_PLCA_CAVA: placa }, { emitEvent: false });

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.resultado = null;
    this.consultado = false;

    this.patioService.GetPosicaoCaminhao(placa).subscribe({
      next: (res: IPosicaoCaminhaoPatioResponse) => {
        this.resultado = res;
        this.consultado = true;
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.consultado = true;
        if (err?.status === 404) {
          this.resultado = null;
        } else {
          this.swalAlert.handleError(err, 'Erro', 'Erro ao consultar posição do caminhão.');
        }
      }
    });
  }

  limpar(): void {
    this.form.reset({ TX_PLCA_CAVA: '' });
    this.resultado = null;
    this.consultado = false;
  }
}
